// extracted by mini-css-extract-plugin
export default {"page_wrapper":"landing-page-screen_page_wrapper__mLngh"};